<template>
  <div class="kol_table">
    <div>共{{pagination.total_count || 0}}个结果</div>
    <div class="header-wrap">
      <div class="left aside">达人信息</div>
      <ul class="table-header" ref="tableHeader">
        <li>
          粉丝数
          <img @click="sortChange('follower')" class="sort_icon" src="../../../assets/sort.png" alt="">
        </li>
        <li>预期观看人数</li>
        <li v-if="query.marketing_target != 2">
          直播互动率
          <img @click="sortChange('live_interaction_rate_medium_30d')" class="sort_icon" src="../../../assets/sort.png" alt="">
          <el-tooltip effect="dark" content="近30日直播互动率" placement="bottom">
            <img src="../../../assets/question.png" class="question" alt="">
          </el-tooltip>
        </li>
        <template v-if="query.marketing_target == 1">
          <li>
            粉丝增长量
            <img class="sort_icon" @click="sortChange('fans_increment_within_15d')" src="../../../assets/sort.png" alt="">
            <el-tooltip effect="dark" content="近15日粉丝增长量" placement="bottom">
              <img src="../../../assets/question.png" class="question" alt="">
            </el-tooltip>
          </li>
          <li>
            粉丝增长率
            <img class="sort_icon" @click="sortChange('fans_increment_rate_within_15d')" src="../../../assets/sort.png" alt="">
            <el-tooltip effect="dark" content="近15日粉丝增长率" placement="bottom">
              <img src="../../../assets/question.png" class="question" alt="">
            </el-tooltip>
          </li>
        </template>
        <template v-else-if="query.marketing_target == 2">
          <li>平均观看时长</li>
          <li>带货商品数</li>
          <li>平均销售额</li>
          <li>带货商品价格</li>
          <li>
            带货口碑
            <img @click="sortChange('live_interaction_rate_medium_30d')" class="sort_icon" src="../../../assets/sort.png" alt="">
            <el-tooltip effect="dark" content="带货口碑由抖音平台基于用户评价、售后、投诉等多维度综合计算得出，反映达人带货商品靠谱程度。" placement="bottom">
              <img src="../../../assets/question.png" class="question" alt="">
            </el-tooltip>
          </li>
          <li>
            GPM
            <el-tooltip effect="dark" content="近30日千次购物车曝光产生的平均销售额" placement="bottom">
              <img src="../../../assets/question.png" class="question" alt="">
            </el-tooltip>
          </li>
        </template>
        <template v-else-if="query.marketing_target == 3">
          <li>
            组件点击量
            <img @click="sortChange('median_game_item_component_click_90_days_range')" class="sort_icon" src="../../../assets/sort.png" alt="">
            <el-tooltip effect="dark" content="近90日星图游戏直播点击量中位数" placement="bottom">
              <img src="../../../assets/question.png" class="question" alt="">
            </el-tooltip>
          </li>
          <li>
            游戏CPC
            <el-tooltip effect="dark" content="近90日星图游戏直播每点击成本中位数" placement="bottom">
              <img src="../../../assets/question.png" class="question" alt="">
            </el-tooltip>
          </li>
        </template>



      </ul>
      <div class="right aside">
        报价
      </div>
    </div>
    <div class="content-wrap">
      <div class="left aside">
        <div class="item-wrap" v-for="({attribute_datas: item} = tempItem, index) in list" :key="index">
          <img :src="item.avatar_uri" alt="" class="avatar">
          <div class="info-container">
            <div class="top-info">
              <div class="name" :title="item.nick_name">{{item.nick_name}}</div>
              <img v-if="item.gender == 1" src="./../../../assets/man.png" style="width: 20px;height: 20px;">
              <img v-if="item.gender == 2" src="./../../../assets/woman.png" style="width: 20px;height: 20px;">
              <span>{{(['北京市', '上海市', '天津市', '重庆市'].includes(item.province) ? item.province : item.city) || '-'}}</span>
            </div>
            <div class="belong-tags">
              <i v-if="list[index].mcn && (list[index].mcn === '畅玩文化' || list[index].mcn.includes('畅玩达人'))">畅玩达人</i>
              <i v-if="list[index].logings">{{list[index].logings || ''}}</i>
            </div>
            <div class="author-content-style-tags">
              <template v-if="Object.keys(item.tags_relation || {}).length">
                <span v-for="(val, key) in item.tags_relation" :key="key">
                  {{key}}
                </span>
              </template>
              <span v-else>暂无标签</span>
            </div>
            <div class="authore-commend-tags"></div>
          </div>
        </div>
      </div>
      <div class="ul-wrap" ref="ulWrap">
        <ul class="table-wrap" v-for="({attribute_datas: item} = tempItem, index) in list" :key="'table' + index">
          <li>{{item.follower | handleNum}}</li>
          <li>{{item.expected_play_num | handleNum}}</li>
          <li v-if="query.marketing_target != 2">{{item.live_interaction_rate_medium_30d ? (item.live_interaction_rate_medium_30d * 100).toFixed(0) : 0}}%</li>
          <template v-if="query.marketing_target == 1">
            <li>{{(item.fans_increment_within_15d * 1).toLocaleString()}}</li>
            <li>{{item.fans_increment_rate_within_15d / 100 < 0 ? 0 : (item.fans_increment_rate_within_15d / 100).toFixed(2)}}%</li>
          </template>
          <template v-else-if="query.marketing_target == 2">
            <li>{{item.live_avg_watch_duration_30d ? (item.live_avg_watch_duration_30d / 60).toFixed(1) + '分钟' : 0}}</li>
            <li>{{item.ecom_live_product_num_30d || 0}}</li>
            <li>{{item.avg_sale_amount_range || '-'}}</li>
            <li>{{item.ecom_main_price_30days ? item.ecom_main_price_30days.toFixed(0) : 0}}</li>
            <li>{{item.ecom_score ? item.ecom_score.toFixed(0) : '-'}}</li>
            <li>{{item.ecom_gpm_30days_range || 0}}</li>
          </template>
          <template v-else-if="query.marketing_target == 3">
            <li>{{item.median_game_item_component_click_90_days_range || '-'}}</li>
            <li>{{item.median_game_item_cpc_90_days_range || '-'}}</li>
          </template>
        </ul>
      </div>
        <div class="right aside">
          <div class="item-wrap" :key="index" v-for="(item, index) in list">
            <span class="price">¥{{item.common_datas | getPrice}}<i>/小时</i></span>
            <div class="btn" :key="index" @click="viewDetail(item)">详情</div>
          </div>
        </div>
    </div>

    <div class="pages">
      <el-pagination background layout="prev, pager, next" :total="pagination.total_count"
        @current-change='pageChange' :page-size="20" :current-page.sync="pagination.curPage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    props:["marketing_target","commonQuery","tableVideoData"],
    data() {
      return {
        query:{},
        tableData:[],
        pagination: {
          total_count: 100,
          curPage:1
        },
        sort_type: true,
        leftnum1: 0,
        leftnum2: 0,
        fixedShow: false,
        fixedHeader: true,
        list: [],
        action: 'query', // query sort page  不是page时，要重置page，否则page不变
        order_by: '',
        sort_type: 2, // 2  降序
      };
    },
    created() {
      this.query = this.commonQuery
      this.query.marketing_target = 1
      this.query.hz = 1
      this.getTableData(this.query)
    },
    watch: {
      commonQuery:{
        deep: true,
        handler(val, oldval){
          this.query = val
          this.getTableData()
        }
      },
      tableVideoData:{
        deep: true,
        handler(val, oldval){
          if(val!==""){
            this.getVideoData(this.tableVideoData)
          }
        }
      }
    },
    filters: {
      handleNum(val){
        if(!val || val === 'null'){return '-'}
        return val >= 10000 ? (val / 10000).toFixed(1) + 'w' : val
      },
      getPrice(val){
        let {task_infos = []} = val
        let {price_infos = []} = task_infos[0] || {}
        if(price_infos.length){
          let list = JSON.parse(JSON.stringify(price_infos))
          list.sort((a, b) => {
            return a.price - b.price
          })
          return list[0].price.toLocaleString()
        }else{
          return '-'
        }
      }
    },
    methods: {
      sortChange(field){
        this.action = 'sort'
        if(this.order_by === field){
          this.order_by = ''
        }else{
          this.order_by = field
        }
        this.getTableData()
      },
      getTableData(){

        if(this.action !== 'page'){this.pagination.curPage = 1}

        let params = JSON.parse(JSON.stringify(this.query))

        // let list = ['hz', 'tcount', 'mcn']
        // for (const key in params) {
        //   if(list.includes(key)){
        //     delete params[key]
        //   }
        // }
        if(this.order_by){
          params.order_by = this.order_by
          params.sort_type = this.sort_type
        }
        params.marketing_target = 6
        params.page = this.pagination.curPage
        this.$axios.get(`author-livelist`, {params}).then(res => {
          if(res.data.code === 0){
            res = res.data.data || {}
            let {pagination = {}, authors = []} = res
            // this.parseData(authors)
            authors.forEach(x=>{
              this.parseData(x.attribute_datas)
              this.parseData(x.common_datas)
            })
            this.list = authors
            this.pagination.total_count = pagination.total_count
          }
        }).finally(() => {
          this.action = 'query'
        })
      },
      parseData(data){
        if(data instanceof Array){
          data.forEach(x => {
            this.parseData(x)
          })
        }else if(Object.prototype.toString.call(data) === '[object Object]'){
          for (const key in data) {
            if(typeof data[key] === 'string'){
              data[key] = data[key] ? JSON.parse(data[key]) : ''
            }else {
              this.parseData(data[key])
            }
          }
        }
      },
      getVideoData(videoQuery){
        this.$api.getData.getVideoData(videoQuery).then(res => {
          this.tableData = res.data.data.authors;
          this.dataOrganize(res)
        })
      },
      dataOrganize(res) {
        if (this.tableData && this.tableData.length !== 0) {
          this.tableData = this.tableData.map(t => {
            if(t.tags_level_two&&t.tags_level_two.includes('["')){
              t.tags_level_two = JSON.parse(t.tags_level_two)[0];
            }

            if (typeof (t.play_over_rate_within_30d) === 'object') {
              t.play_over_rate_within_30d = 0
            }
            if (t.main_category_30d) {
              t.main_category_30d = Object.keys(t.main_category_30d).join(',') + '';
            }
            if(t.tags&&t.tags.includes('["')){
              t.tags = JSON.parse(t.tags);
            }

            return t
          })
          this.tableData = this.tableData.map(t => {
            t = {
              ...t,
              ...{
                price: t.price_info.length === 0 ? 0 : t.price_info[0].price
              }
            }
            return t
          })
        }
        this.pagination.total_count = res.data.data.pagination?.total_count ?? 0
      },
      sort(val) {
        this.pagination.curPage=1
        let query
        if(val.prop==="price"){
          if(val.order==="descending"){
            query = {
              ...this.query,
              ...{
                order_by: val.prop,
                sort_type: 2
              }
            }
          }else if(val.order==="ascending"){
            query = {
              ...this.query,
              ...{
                order_by: val.prop,
                sort_type: 1
              }
            }
          }else{
            query = {
              ...this.query,
              ...{
                order_by: val.prop,
                sort_type: ''
              }
            }
          }
        }else{
          query = {
            ...this.query,
            ...{
              order_by: val.prop,
              sort_type: this.sort_type ? 2 : ''
            }
          }
          this.sort_type = !this.sort_type
        }
        query.page=1
        this.$emit('changeQuery',query,"commonQuery");
      },
      tableBtnClick(val) {
        let routeData = this.$router.resolve({
          path: '/daren',
          query: {
            id: val.id
          }
        })
        window.open(routeData.href, "_blank");
      },
      tableSameClick(val) {
        let routeData = this.$router.resolve({
          path: '/same',
        })
        let same= {value:val.nick_name,id:val.id}
        window.sessionStorage.setItem('same',JSON.stringify(same))
        window.open(routeData.href, "_blank");
      },
      pageChange(page) {
        this.action = 'page'
        this.pagination.curPage = page
        this.getTableData()
      },
      viewDetail(item){
        LA.track('dy_live_talentinfo');
        this.$router.push({path: '/live-talent-detail', query: {id: item.attribute_datas.id}})
      }
    },
    mounted() {
      let el1 = this.$refs.tableHeader;
      let el2 = this.$refs.ulWrap;
      el1.addEventListener('scroll', (e)=> {
        e.stopPropagation();
        el2.scrollLeft = el1.scrollLeft;
      });
      el2.addEventListener('scroll', (e)=> {
        e.stopPropagation();
        el1.scrollLeft = el2.scrollLeft;
      });

    },
  };
</script>

<style lang="less" scoped>
.kol_table{
  .header-wrap{
    display: flex;
    align-items: center;
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 10;
    margin-top: 10px;
    border-bottom: 1px solid #f0f0f0;
    background: #fff;
    .aside{
      width: 380px;
      padding-left: 24px;
      box-sizing: border-box;
    }
    .table-header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: calc(100% - 380px - 380px);
      overflow-x: auto;
      li{
        min-width: 150px;
        img{
          cursor: pointer;
          margin-left: 5px;
        }
      }
    }
  }
  .content-wrap{
    display: flex;
    .aside{
      min-height: 128px;
      width: 380px;
      box-sizing: border-box;
      &.left{
        >.item-wrap{
          display: flex;
          align-items: center;
          height: 134px;
          padding-left: 24px;
          border-bottom: 1px solid #f0f0f0;
          img{
            width: 70px;
            height: 70px;
            border-radius: 50%;
          }
          .info-container{
            margin-left: 24px;
            .top-info{
              display: flex;
              align-items: center;
              margin-bottom: 8px;
              .name{
                font-weight: 600;
                font-size: 18px;
                line-height: 20px;
                cursor: pointer;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                max-width: 170px;
              }
              img{
                width: 16px;
                height: 16px;
                margin-left: 8px;
              }
              span{
                margin-left: 8px;
                font-size: 14px;
              }
            }
            .author-content-style-tags{
              span{
                padding: 4px 12px;
                white-space: nowrap;
                background: #f5f5f5;
                border-radius: 100vmax;
                height: 26px;
                line-height: 26px;
                margin-right: 8px;
                font-weight: 400;
                font-size: 14px;
              }
            }
            .belong-tags{
              display: flex;
              i{
                margin: 5px 0;
                padding: 2px 4px;
                height: 20px;
                line-height: 20px;
                background: #fff2eb;
                color: #ff5c00;
                border-radius: 2px;
                text-align: center;
                &:not(:last-child){
                  margin-right: 5px;
                }
              }
            }
          }
        }

      }
      &.right{
        .item-wrap{
          height: 134px;
          line-height: 134px;
          border-bottom: 1px solid #f0f0f0;
          display: flex;
          align-items: center;
          padding-left: 24px;
          .price{
            font-size: 18px;
            font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
            font-weight: 800;
            color: #FF5C00;
            width: 150px;
            margin-right: 40px;
            i{
              font-size: 14px;
              color: #999;
              font-weight: normal;
            }
          }
          .btn{
            text-align: center;
            border: none;
            width: 72px;
            height: 30px;
            background: #FF6F28;
            border-radius: 2px;
            font-size: 14px;
            font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 30px;
            cursor: pointer;
          }
        }

      }
    }
    .ul-wrap{
      overflow-x: auto;
      width: calc(100% - 380px - 380px);
      .table-wrap{
        margin: 0;
        padding: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;
        padding-left: 40px;
        li{
          min-width: 150px;
          height: 134px;
          line-height: 134px;
        }
      }
    }

  }
}
</style>

